/**
 * Helper function to add dashes to a phone number
 *
 * @example formatNumber('180002984469') // returns '1-800-298-4469'
 *
 * @param s String of phone number that needs formatting with dashes.
 * @returns String of phone number with dashes.
 */
export const formatNumber = (s?: string) => {
  if (!s || s.length < 10 || s.length > 11) {
    return;
  }

  if (s.length === 10) {
    return `${s.substring(0, 3)}-${s.substring(3, 6)}-${s.substring(6)}`;
  }

  return `${s.substring(0, 1)}-${s.substring(1, 4)}-${s.substring(
    4,
    7
  )}-${s.substring(7)}`;
};

/**
 * Helper function to remove dashes in a phone number
 *
 * @example stripNumber('1-800-298-4469') // returns '18002984469'
 *
 * @param s String of digits with dashes in it
 * @returns String of numbers without the dashes or any characters inbetween.
 */
export const stripNumber = (s: string) => s.replace(/\D/g, '');

export const maskEmail = (email: string) => {
  // assuming email has a valid format
  const parsedEmail = email.split('@');
  const masked = parsedEmail[0].split('').map((char, index) => {
    if (index > 1) {
      return '*';
    }
    return char;
  });
  return `${masked.join('')}@${parsedEmail[1]}`;
};

export const maskPhoneNumber = (phoneNumber: string) => {
  // assuming phone number has 10 digits
  const slicedNumber = phoneNumber.slice(6);
  return `*** *** ${slicedNumber}`;
};
